import * as React from "react";
import { localedFormat, MOBILE_MAX_WIDTH } from "../../utils";
import parseISO from "date-fns/parseISO";
import { parse, isValid } from "date-fns";
import MaskedInput from "react-text-mask";
import Select from "../Select/Select";
import "./DateInputFormat.css";
import { useMediaQuery } from "react-responsive";

interface Props {
	date: string;
	name: string;
	onChange: (value: Date) => void;
	label: string;
	minYear?: number;
	disableDelete?: boolean;
	hideDay?: boolean;
}

const InputType: React.FC = (props) => {
	const { inputRef, ...otherProps } = props as any;

	return (
		<MaskedInput
			{...otherProps}
			ref={(ref: any) => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/]}
			showMask={true}
			inputMode="numeric"
		/>
	);
};

const DateInputFormat: React.FC<Props> = (props) => {
	const inputRef = React.useRef<HTMLInputElement>(null);
	const formattedDate = localedFormat(parseISO(props.date), "dd.MM.yyyy");
	const [valid, setValid] = React.useState(true);

	const date = props.date ? parseISO(props.date) : null;

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	const [day, setDay] = React.useState(date?.getDate() || "");
	const [month, setMonth] = React.useState(date?.getMonth() || "");
	const [year, setYear] = React.useState(date?.getFullYear() || "");

	const months = [
		"января",
		"февраля",
		"марта",
		"апреля",
		"мая",
		"июня",
		"июля",
		"августа",
		"сентября",
		"октября",
		"ноября",
		"декабря",
	];

	const dayItems = React.useMemo(() => {
		const days = [];

		if (isMobile) {
			days.push({
				value: '',
				name: ''
			})
		}

		for (let i = 1; i < 32; i++) {
			days.push({
				value: i,
				label: i.toString(),
			});
		}

		return days;
	}, []);

	const monthItems = React.useMemo(() => {
		const month = [];

		if (isMobile) {
			month.push({
				value: '',
				name: ''
			})
		}

		for (let i = 0; i < 12; i++) {
			month.push({
				value: i,
				label: months[i],
			});
		}

		return month;
	}, []);

	const yearItems = React.useMemo(() => {
		const years = [];
		const start = props.minYear ? props.minYear : new Date().getFullYear() - 10;
		const finish = new Date().getFullYear() + 10;

		if (isMobile) {
			years.push({
				value: "",
				label: ""
			})
		}

		for (let i = start; i < finish; i++) {
			years.push({
				value: i,
				label: i.toString(),
			});
		}

		return years;
	}, []);

	React.useEffect(() => {
		if (day && (month || month === 0) && year) {
			const resultStr = `${day}-${
				parseInt(month ? (month as any) : 0) + 1
			}-${year}`;

			const parsed = parse(resultStr, "d-M-yyyy", new Date());

			if (isValid(parsed)) {
				if (props.hideDay) {
					
				}

				props.onChange(parsed ? parsed : null);
			} else {
				setValid(false);
			}
		}
	}, [day, month, year, props.hideDay]);

	React.useEffect(() => {
		const date = props.date ? parseISO(props.date) : null;

		setDay(date?.getDate());
		setMonth(date?.getMonth());
		setYear(date?.getFullYear());
	}, [props.date]);

	const onClear = () => {
		props.onChange(null);
	};

	return (
		<>
			<div className="dates__Select">
				<div className="dates__Select__wrapper">
					{!props.hideDay && <Select
						items={dayItems as any}
						label="день"
						value={day || ""}
						onChange={(e) => setDay(e.target.value as any)}
						formClassName="dates__Select__select"
						native={isMobile}
					/>}
					<Select
						items={monthItems as any}
						label="месяц"
						value={month || ""}
						onChange={(e) => setMonth(e.target.value as any)}
						formClassName="dates__Select__select"
						native={isMobile}
					/>
					<Select
						items={yearItems as any}
						label="год"
						value={year || ""}
						onChange={(e) => setYear(e.target.value as any)}
						formClassName="dates__Select__select"
						native={isMobile}
					/>
				</div>

				{!props.disableDelete && props.date && <div className="dates__Select__clear" onClick={onClear}>очистить</div>}

				<input
					name={props.name}
					value={props.date}
					ref={inputRef}
					type="hidden"
				/>
			</div>
		</>
	);
};

export default DateInputFormat;
